<div *ngIf="generalError || loading" class="mc-loader mc-log-stream-grid-overlay">
  <mc-errors-expansion-panel *ngIf="generalError" [generalError]="generalError" [detailedErrors]="detailedErrors"></mc-errors-expansion-panel>
  <ng-container *ngIf="!generalError">
    <p class="mc-form-text">Loading log...</p>
    <mat-progress-bar class="mc-progress-bar-large" color="accent-vivid" mode="indeterminate"></mat-progress-bar>
  </ng-container>
</div>
<mc-data-grid *ngIf="!generalError && !loading" [gridControl]="gridControl" [gridId]="gridId" [defaultVisibleColumns]="defaultVisibleColumns">
  <ng-template mcGridCell="LogMessageType" let-data>
    <mat-icon fontSet="project-titan" [fontIcon]="logMessageTypeIcon(data.LogMessageType)" [matTooltip]="logMessageTypeLabel(data.LogMessageType)" [attr.aria-label]="logMessageTypeLabel(data.LogMessageType)" class="mc-image-icon {{ logMessageTypeColorClass(data.LogMessageType) }}"></mat-icon>
  </ng-template>

  <ng-template mcGridCell="Message" let-data>
    <div class="mc-log-stream-grid-text-container" *ngIf="data.Message">
      <div class="mc-log-stream-grid-text mc-truncate" [matTooltip]="data.Message">
        {{ data.Message }}
      </div>
      <div class="mc-log-stream-grid-text-actions">
        <button mat-icon-button (click)="openLogDialog(data.Message)" matTooltip="View message">
          <mat-icon fontSet="project-titan" fontIcon="icon-view"></mat-icon>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template mcGridCell="File" let-data>
    <ng-container *ngIf="data.File">
      <a *ngIf="getSourceRouterLink(data.File, data.LineIndex) as sourceLink; else sourcePlain"
         class="mc-log-stream-grid-source-link mc-truncate"
         [routerLink]="sourceLink"
         [queryParams]="data.LineIndex ? { line: data.LineIndex } : null"
         [matTooltip]="sourceLabel(data.File, data.LineIndex)">{{ sourceLabel(data.File, data.LineIndex) }}</a>
      <ng-template #sourcePlain>
        <span class="mc-truncate" [matTooltip]="sourceLabel(data.File, data.LineIndex)">{{ sourceLabel(data.File, data.LineIndex) }}</span>
      </ng-template>
    </ng-container>
  </ng-template>

  <ng-template mcEmptyGrid="unfiltered">{{ emptyLabel }}</ng-template>
</mc-data-grid>
